export const drawerWidth = 350

export default drawerWidth